export default "__VITE_ASSET__CbRE8zvl__"